import React from 'react';

const ToolbarIcons = {
  ProfileManagement: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    className,
  }) => (
    // <svg
    //   xmlns='http://www.w3.org/2000/svg'
    //   width={width}
    //   height={height}
    //   version='1.1'
    //   viewBox='0 0 547 569.22'
    //   fill={fill}
    //   className={className}
    // >
    //   <g id='Layer_x0020_1'>
    //     <metadata id='CorelCorpID_0Corel-Layer' />
    //     <g id='_2822688298608'>
    //       <path
    //         className='fil0'
    //         d='M286.64 526.01c-142.54,5.55 -256.26,-108.34 -251.92,-244.8 4.8,-150.88 115.47,-227.83 237.52,-230.92 125.88,-3.18 255.8,78.96 258.03,235.33 1.93,135.23 -100.45,234.81 -243.63,240.39zm-219.56 -239.06c2.04,122.3 110.49,217.76 220.92,210.72 115.23,-7.35 200.87,-84.31 206.06,-198.11 5.53,-121.25 -76.83,-225.07 -220.28,-226.84 -108.05,-1.33 -208.8,88.37 -206.7,214.23z'
    //       />
    //       <path
    //         className='fil0'
    //         d='M249.84 184.96c25.16,16.36 91.04,59.15 124.81,80.67 11.99,7.64 14.01,23.79 1.94,32.74 -38.09,28.24 -84.46,56.84 -124.65,82.02 -17.02,10.66 -37.22,2.83 -37.43,-17.32 -0.41,-41.87 -0.69,-116.1 -0.81,-159.79 -0.02,-12.06 3.8,-17.84 9.76,-21.4 5.99,-3.58 14.15,-4.88 26.38,3.07z'
    //       />
    //       <path
    //         className='fil0'
    //         d='M252.36 0.69c149.32,-7.77 224.56,51.19 294.65,148.85 -5.91,2.92 -62.13,28.46 -63.97,29.29 -39.84,-65.42 -88.08,-119.93 -191.95,-123.41 -117.27,-3.94 -219.03,105.74 -220.51,221.88 -1.85,145.03 102.7,220.24 220.18,220.39 99.93,0.13 152.64,-45.63 185.76,-109.54 -0.18,0.43 62.89,30.29 69.08,33.4 -61.18,107.02 -165.67,147.83 -256.1,147.66 -151.84,-0.28 -287.35,-96.41 -289.48,-283.96 -1.65,-145.51 107.61,-277.05 252.34,-284.57z'
    //       />
    //     </g>
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <g id="_2822688298608" data-name=" 2822688298608">
          <path
            d="M33.17,53.72A21.37,21.37,0,0,1,10.71,31.89C11.13,18.43,21,11.57,31.89,11.29c11.22-.28,22.81,7.05,23,21C55.07,44.34,45.94,53.22,33.17,53.72ZM13.59,32.4c.18,10.9,9.85,19.42,19.7,18.79,10.28-.66,17.92-7.52,18.38-17.67C52.16,22.71,44.82,13.45,32,13.29A18.51,18.51,0,0,0,13.59,32.4Z"
            fillRule="evenodd"
          />
          <path
            d="M29.89,23.3C32.13,24.76,38,28.58,41,30.5a1.73,1.73,0,0,1,.17,2.92c-3.39,2.52-7.53,5.07-11.11,7.31-1.52,1-3.32.25-3.34-1.54,0-3.74-.06-10.36-.07-14.25A1.93,1.93,0,0,1,27.54,23a2.05,2.05,0,0,1,2.35.27Z"
            fillRule="evenodd"
          />
          <path
            d="M30.11,6.87c13.32-.69,20,4.57,26.28,13.27-.53.27-5.54,2.54-5.7,2.62-3.56-5.84-7.86-10.7-17.12-11C23.11,11.4,14,21.18,13.9,31.54c-.16,12.93,9.16,19.64,19.64,19.65,8.91,0,13.61-4.07,16.56-9.77,0,0,5.61,2.7,6.16,3A25.85,25.85,0,0,1,33.43,57.57C19.89,57.54,7.8,49,7.61,32.25c-.15-13,9.6-24.71,22.5-25.38Z"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  ),

  SettingsIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 559.6 564.28"
      fill={fill}
      className={className}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M221.2 0c45.11,0 72.15,0 117.27,0 17.13,0.3 26.09,14.18 30.94,24.82 10.99,24.12 -0.35,59.09 28.2,65.41 32.63,7.24 52.53,-27 83.46,-11.28 25.35,12.89 59.77,82.58 74.44,109.41 23.05,42.16 -59.08,60.62 -50.76,101.5 4.83,23.71 18.81,29.62 37.6,45.12 14.81,12.22 13.36,39.81 4.71,54.3 -13.52,22.67 -29.45,51.69 -51.07,85.94 -12.38,19.62 -32.68,19.15 -52.5,7.8 -17.25,-9.88 -33.39,-18.86 -52.66,-7.05 -18.02,11.04 -16.14,26.42 -18.33,46.51 -2.99,27.38 -14.22,40.71 -40.71,40.99 -39.19,0.43 -70.44,0.8 -105.93,0.82 -19.71,0.01 -37.89,-14.57 -38.67,-37.1 -1.53,-44.28 -13.44,-52 -24.31,-56.75 -31.44,-13.71 -68.99,49.81 -105.65,0.96 -18.31,-31.77 -38.09,-66.13 -54.38,-95.81 -5.07,-9.57 -4.76,-28.41 12.63,-44.21 15.63,-14.18 37.72,-28.19 38.69,-49.76 1.24,-27.29 -21.24,-37.46 -38.94,-50.38 -15.98,-11.66 -12.42,-43.44 -6.1,-54.28 17.08,-29.31 30.32,-51.55 48.99,-82.22 15.42,-25.33 33.92,-21.16 52.18,-14.26 17.24,6.51 37.08,18.98 54.97,8.63 21.33,-12.33 14.94,-38.9 22.56,-62.03 4.06,-12.33 19.02,-26.65 33.38,-27.07zm16.96 56.63c-6.21,43.72 -19.45,69.39 -39.4,81.91 -23.45,14.73 -56.2,11.33 -97.75,-2.17 -6.12,9.18 -33.11,56.4 -42.03,72.1 36.88,26.34 52.6,53.78 50.3,80.84 -2.13,25.09 -19.73,49.87 -50.3,73.18 14.01,24.03 28.02,48.06 42.03,72.1 38.64,-12.1 69.53,-19.02 90.72,-5.61 23.8,15.06 38.02,34 44.21,83.17 28.75,0 57.51,0 86.27,0 3.55,-30.24 13.02,-62.68 39.12,-79.5 28.95,-18.66 70.61,-12.59 95.81,0.84 7.56,-12.49 32.45,-55.52 42.03,-72.1 -34.09,-23.05 -46.06,-49.86 -45.67,-74.96 0.53,-34.12 23.92,-65.07 45.67,-79.05 -14.01,-24.03 -28.02,-48.07 -42.03,-72.1 -41.03,17.24 -73.43,18.13 -96.42,2.69 -20.49,-13.77 -33.51,-40.52 -38.51,-80.25 -28.02,-0.36 -56.04,-0.73 -84.05,-1.09z"
        />
        <path
          className="fil0"
          d="M275.79 169.18c80,1.25 139.92,76.16 106.02,159.03 -40.51,99.01 -189.85,81.23 -213.01,-17.59 -15.71,-67.03 37.7,-142.52 107,-141.44zm-53.8 99.08c-10.02,41.3 29.34,81.21 70.91,70.91 44.34,-11 55.38,-65 30.96,-94.97 -28.39,-34.83 -89.96,-24.98 -101.87,24.06z"
        />
      </g>
    </svg>
  ),
  VideoIconToolbar: ({ width = '24px', height = '24px', fill, className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 558.15 365.4"
      fill={fill}
      className={className}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M37.24 0.02c57.84,0.12 274.27,-0.04 361.73,-0.01 28.3,0.02 47.91,19.42 47.91,49.07 -0.03,52.59 -0.11,48.79 -0,89.19 12.61,-10.97 106.39,-69.34 111.28,-73.57 -0.19,94.75 -0.38,166.58 0,260.48 -12.39,-11.32 -108.35,-94.61 -111.27,-97.2 -0.01,31.49 -0.01,52.84 -0.01,90.11 -0.01,44.15 -23.35,47.27 -61.5,47.29 -119.73,0.06 -230.1,-0.04 -349.52,-0.05 -24.35,-0.04 -35.87,-17.9 -35.85,-34.88 0,-111.29 0,-179.4 0,-290.69 0,-21.44 14.98,-39.64 37.24,-39.74zm151.76 88.26c-0.01,32.23 0.06,31.77 -0.01,63.87 -26.86,-0.03 -43.84,-0.01 -63.82,-0.02 -44.94,0.44 -45.97,60.14 0.02,60.82 34.17,0.04 29.44,0.04 63.81,0.02 0,31.15 0,36.05 0,67.2 -0.35,43.08 67.02,40.92 66.5,0 -0.23,-31.99 0.3,-34.81 -0.01,-67.21 26.91,-0.01 44.12,0.04 67.86,0.01 46.24,-0.44 43.79,-60.85 -0.11,-60.79 -26.6,-0.06 -52.62,-0.11 -67.79,-0.21 0.05,-29.97 0.04,-33.46 0.05,-63.69 0.69,-46.36 -66.29,-47.57 -66.5,0z"
        />
      </g>
    </svg>
  ),
  SearchIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 478.67 478.62"
      fill={fill}
      onClick={onClick}
      className={className}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M327.8 278.62c53.67,53.67 85.61,86.09 139.29,139.76 33.76,35.16 -13.31,84.86 -51.12,48.57 -21,-20.67 -121.23,-118.31 -140.09,-137.51 -62.18,41.81 -172.56,37.3 -232.92,-32.16 -59.04,-67.93 -63.52,-187.14 26.59,-260.63 71.27,-58.12 189.51,-44.14 246.68,20.98 55.41,63.11 67.86,154.79 11.59,220.99zm-223.03 -185.73c-51.66,45.75 -46.75,119.43 -12.23,159.66 39.82,46.41 117.09,54.59 170.26,2.95 44.26,-42.99 40.67,-117.4 2.56,-155.63 -40.34,-40.47 -105.33,-55.92 -160.59,-6.98z"
        />
      </g>
    </svg>
  ),
  ChatIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   id='Layer_1'
    //   data-name='Layer 1'
    //   xmlns='http://www.w3.org/2000/svg'
    //   viewBox='0 0 64 64'
    // >
    //   <g id='Layer_1-2' data-name='Layer_1'>
    //     <path d='M11.88,7.16a5.31,5.31,0,0,0-5.13,5.36c0,8,0,15.54,0,23.44,0,5.61,1.52,8,7.67,8l15.63,0,8.18,6.61c2.51,2,4.77,3.86,6.31,5.08.32.27.5.39.75.59a1,1,0,0,0,1,.23.82.82,0,0,0,.4-.78c0-.29,0-.42,0-.79,0-1.07,0-2.5,0-4.25V43.91c1.7,0,3.38,0,5.06,0A5.58,5.58,0,0,0,57.07,38V11.55c-.22-3.12-2-4.48-4.51-4.48L32.18,7c-11.55,0-18.87.11-20.32.13ZM52,15.57c0,1.9,0,5,0,9.94,0,5.18,0,7.84,0,9.68,0,2.22-1.14,3.52-3.56,3.56-.66,0-1.93,0-3,0H43.52a1.91,1.91,0,0,0-1.93,1.89v2c0,1.39,0,2.55-.05,3.23,0,.25-.07.33-.14.36s-.22,0-.45-.14c-.8-.63-2.47-1.95-4.34-3.47L32.19,39a1.45,1.45,0,0,0-.89-.27H22.17c-2.68,0-4.64,0-6.09,0-3.59,0-4.2-2.09-4.25-4.77s0-4.57,0-8.43c0-4.43,0-7.33,0-9.24,0-2.2.93-4.07,3.93-4.11,2.83,0,8.26-.07,16.24-.07H48.4c2.16,0,3.56,1.11,3.59,3.45Z' />
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M12.93,7.05c-4.06,0-6.19,2.66-6.29,5.42,0,8.08.05,15.67,0,23.61,0,5.66,3.39,7.88,6.39,8h17l8.22,6.67,6.34,5.13c.34.24.48.39.77.58a1.14,1.14,0,0,0,1,.25.78.78,0,0,0,.39-.78v-.77c0-1.07,0-2.52,0-4.31V45a.87.87,0,0,1,.92-.92c1.45,0,2.76,0,4.21,0a5.59,5.59,0,0,0,5.32-6V12.76A6.26,6.26,0,0,0,51.78,7l-19.55,0c-11.61,0-17.85.1-19.35.1Zm40.54,7.74c0,1.89.05,5.76.05,10.74,0,5.22,0,9.48,0,11.37,0,2.22-.73,3.19-3.15,3.24-.67,0-2.42,0-3.53,0-2.08,0-3.87,0-3.87,3.19v5c0,.25-.05.34-.14.39s-.25,0-.44-.14c-.82-.63-3.77-3-5.66-4.5l-4.45-3.63a1.34,1.34,0,0,0-.92-.24H22.22c-2.71,0-5.71-.05-7.16-.15C12,40,10.56,38.74,10.56,35s-.05-5.46-.05-9.33c0-4.45.05-8.66.05-10.6,0-2.22,1-4.16,4-4.16,2.85,0,9.48,0,17.56,0l17.85.1c2.18,0,3.58,1.55,3.63,3.87Z" />
      </g>
    </svg>
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   version='1.1'
    //   xmlns='http://www.w3.org/2000/svg'
    //   x='0px'
    //   y='0px'
    //   viewBox='0 0 1000 1000'
    //   enableBackground='new 0 0 1000 1000'
    // >
    //   <metadata>
    //     {' '}
    //     Svg Vector Icons : http://www.onlinewebfonts.com/icon{' '}
    //   </metadata>
    //   <g>
    //     <g transform='translate(0.000000,511.000000) scale(0.100000,-0.100000)'>
    //       <path d='M4418.9,4156.6c-241.6-57.5-454.5-270.4-521.6-525.5c-23-92.1-28.8-245.5-28.8-838.1v-723l-1605.2-5.8l-1607.1-5.7l-115.1-46c-157.3-63.3-331.8-237.8-395.1-395.1l-46-115.1V-147v-1649.3l61.4-128.5c72.9-155.3,195.6-280,347.1-354.8c105.5-51.8,118.9-53.7,467.9-59.4l360.5-7.7l3.8-801.6l5.8-803.6l991.5,803.6l991.5,803.5l1137.3,5.8l1137.3,5.7l109.3,53.7c141.9,69,304.9,245.5,364.4,391.2c42.2,109.3,44.1,126.6,49.9,884.1l5.8,771h268.5h268.5l978.1-790.1c537-435.3,985.8-794,995.4-797.8c13.4-3.8,19.2,276.2,19.2,788.2v795.9l360.5,7.7c352.9,5.8,360.5,5.8,469.9,61.4c138.1,71,287.7,226.3,354.8,370.1l51.8,111.2v1658.9v1658.9l-61.4,126.6c-74.8,153.4-212.9,287.7-366.3,358.6l-109.3,51.8l-2435.6,3.8C5548.5,4171.9,4461.1,4166.2,4418.9,4156.6z M9265.2,3521.8c26.8-38.4,30.7-218.6,30.7-1557.3c0-1382.7-1.9-1517-32.6-1549.6c-28.8-32.6-72.9-34.5-623.3-34.5h-590.7V-79.9c0-253.1-5.8-460.3-13.4-460.3c-9.6,1.9-270.4,209-581.1,460.3L6889,380.4H5728.8c-974.2,0-1167.9,3.8-1200.6,26.8c-34.5,26.8-36.4,69-42.2,1553.4c-3.8,1507.4-3.8,1526.6,34.5,1564.9c38.4,38.4,57.5,38.4,2376.2,38.4h2339.7L9265.2,3521.8z' />
    //     </g>
    //   </g>
    // </svg>
  ),

  CloseIcon: ({
    width = '14px',
    height = '14px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 464.25 461.52"
      fill={fill}
      onClick={onClick}
      className={className}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M448.08 76.87c45.66,-45.59 -15.29,-105.89 -60.64,-60.56 -52.03,52.1 -104.24,104.32 -154.73,154.86 -49.2,-49.2 -105.14,-105.23 -154.33,-154.44 -43.74,-46.91 -106.56,15.08 -64.46,60.51 50.37,50.54 123.19,123.18 156.35,156.33 -49.99,49.88 -104.39,103.82 -150.34,150.6 -46.86,46.08 16.64,103.71 56.73,64.15 52.11,-52.11 108.81,-108.79 154.2,-154.17 49.69,49.77 101.53,101.58 151.25,151.22 39.64,40.45 103.24,-21.91 61.87,-62.8 -41.7,-42.17 -108.76,-108.86 -150.71,-150.85 17.31,-17.37 97.26,-97.29 154.82,-154.85z"
        />
      </g>
    </svg>
  ),
  BurgerIcon: ({
    className,
    width = '24',
    height = '24',
    fill = '#999',
    onClick,
  }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
        fill="#757575"
        fillOpacity="0.54"
      />
    </svg>
  ),
  RefreshIcon: ({
    className,
    width = '20',
    height = '20',
    fill = '#999',
    onClick,
  }) => (
    <svg
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      version="1.1"
      viewBox="0 0 489.533 489.533"
      // xml:space="preserve"
    >
      <g>
        <path
          d="M268.175,488.161c98.2-11,176.9-89.5,188.1-187.7c14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9
		l-118.6,87.1c-2,1.5-2,4.4,0,5.9l118.6,87.1c2.7,2,6.7,0.2,6.7-2.9v-57.5c87.9,1.4,158.3,76.2,152.3,165.6
		c-5.1,76.9-67.8,139.3-144.7,144.2c-81.5,5.2-150.8-53-163.2-130c-2.3-14.3-14.8-24.7-29.2-24.7c-17.9,0-31.9,15.9-29.1,33.6
		C49.575,418.961,150.875,501.261,268.175,488.161z"
        />
      </g>
    </svg>
  ),
  SwitchIcon: ({
    width = '20px',
    height = '20px',
    fill = 'rgba(0,0,0,0.54)',
    onClick,
    className,
  }) => (
    // <svg
    //   xmlns='http://www.w3.org/2000/svg'
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   viewBox='0 0 464.55 472.41'
    //   version='1.1'
    // >
    //   <g id='Layer_x0020_1'>
    //     <metadata id='CorelCorpID_0Corel-Layer' />
    //     <path
    //       className='fil0'
    //       d='M452.44 150.21c-33.61,33 -67.26,66.05 -100.89,99.07 -23.61,22.73 -53.62,-9.25 -27.99,-33.27l67 -66.99 -368.09 0c-29.92,-0.45 -29.98,-43.48 0,-43.38l368.09 0c-22.33,-22.33 -44.66,-44.66 -67,-67 -23.15,-22.13 4.69,-53.61 30.58,-30.6l99.47 99.59 3.25 3.26c9.36,9.32 10.73,23.45 1.03,33.66 -1.63,1.71 -3.42,3.67 -5.45,5.67z'
    //     />
    //     <path
    //       className='fil0'
    //       d='M12.11 365.57c33.61,33 67.26,66.05 100.89,99.07 23.61,22.73 53.62,-9.25 27.99,-33.27l-67 -66.99 368.08 0c29.91,-0.45 29.98,-43.48 0,-43.38l-368.08 0c22.33,-22.33 44.66,-44.66 67,-67 23.15,-22.13 -4.69,-53.61 -30.58,-30.6l-99.47 99.59 -3.25 3.26c-9.36,9.32 -10.73,23.45 -1.03,33.66 1.63,1.71 3.42,3.67 5.45,5.67z'
    //     />
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M55.58,22.91,44.72,33.57c-2.54,2.44-5.77-1-3-3.58l7.21-7.21H9.31a2.34,2.34,0,1,1,0-4.67H48.92L41.71,10.9c-2.49-2.38.51-5.77,3.29-3.29L55.71,18.32l.35.36a2.52,2.52,0,0,1,.11,3.62l-.59.61Z" />
        <path d="M8.2,46.08,19.05,56.74c2.54,2.45,5.77-1,3-3.58L14.86,46H54.47a2.33,2.33,0,1,0,0-4.66H14.86l7.21-7.21c2.49-2.39-.51-5.77-3.3-3.3L8.07,41.5l-.35.35a2.52,2.52,0,0,0-.11,3.62c.18.19.37.4.59.61Z" />
      </g>
    </svg>
  ),
  ExitIcon: ({
    width = '20px',
    height = '20px',
    fill = 'rgba(0,0,0,0.54)',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M57.34,50.8A6.25,6.25,0,0,1,51.21,57H13.91c-2,0-3.88-.27-5.42-1.87a6,6,0,0,1-1.83-4.3v-6.3a2.34,2.34,0,0,1,2.4-2.21,2.39,2.39,0,0,1,2.33,2.22v6.25c0,.82.39,1.46,1.67,1.44h37c1.13,0,2.5.28,2.53-1.4V13.67a1.55,1.55,0,0,0-1.73-1.51h-37c-1.1,0-2.49,0-2.53,1.51v5.55A2.43,2.43,0,0,1,9.1,21.47a2.48,2.48,0,0,1-2.45-2.24c0-2,0-3.69,0-5.65a6.19,6.19,0,0,1,6.19-6.19c12.76,0,25.53,0,38.29,0a6.21,6.21,0,0,1,6.2,6.2V50.81ZM42.06,34.88,29.93,46.79c-2.84,2.73-6.45-1.11-3.36-4l8-8.06H9.37a2.61,2.61,0,1,1,0-5.21H34.62l-8-8.06c-2.79-2.66.56-6.45,3.67-3.68l12,12,.39.39a2.81,2.81,0,0,1,.13,4c-.2.21-.41.45-.66.69Z" />
      </g>
    </svg>
  ),
  changePasswordIcon: ({
    width = '20px',
    height = '20px',
    fill = 'rgba(0,0,0,0.54)',
    onClick,
    className,
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   id="Layer_1"
    //   data-name="Layer 1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 64 64"
    // >
    //   <g id="Layer_1-2" data-name="Layer_1">
    //     <path d="M57.34,50.8A6.25,6.25,0,0,1,51.21,57H13.91c-2,0-3.88-.27-5.42-1.87a6,6,0,0,1-1.83-4.3v-6.3a2.34,2.34,0,0,1,2.4-2.21,2.39,2.39,0,0,1,2.33,2.22v6.25c0,.82.39,1.46,1.67,1.44h37c1.13,0,2.5.28,2.53-1.4V13.67a1.55,1.55,0,0,0-1.73-1.51h-37c-1.1,0-2.49,0-2.53,1.51v5.55A2.43,2.43,0,0,1,9.1,21.47a2.48,2.48,0,0,1-2.45-2.24c0-2,0-3.69,0-5.65a6.19,6.19,0,0,1,6.19-6.19c12.76,0,25.53,0,38.29,0a6.21,6.21,0,0,1,6.2,6.2V50.81ZM42.06,34.88,29.93,46.79c-2.84,2.73-6.45-1.11-3.36-4l8-8.06H9.37a2.61,2.61,0,1,1,0-5.21H34.62l-8-8.06c-2.79-2.66.56-6.45,3.67-3.68l12,12,.39.39a2.81,2.81,0,0,1,.13,4c-.2.21-.41.45-.66.69Z" />
    //   </g>
    // </svg>
    
<svg id="SvgjsSvg1001"       onClick={onClick}
      className={className} width={width} height={height} xmlns="http://www.w3.org/2000/svg" version="1.1" ><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={width} height={height}><g fill="#2b2a3d" class="color2B2A3D svgShape"><path d="M15 8V5c0-2.8-2.2-5-5-5S5 2.2 5 5v3c-1.7 0-3 1.3-3 3v6c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3v-6c0-1.7-1.3-3-3-3zM7 5c0-1.7 1.3-3 3-3s3 1.3 3 3v3H7V5zm9 12c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v6z" fill={fill} class="color000 svgShape"></path><path d="M10 12c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-.6-.4-1-1-1z" fill={fill} class="color000 svgShape"></path></g></svg></g></svg>
  ),
  DeleteAccount: ({
    width = '20px',
    height = '20px',
    fill = 'rgba(0,0,0,0.54)',
    onClick,
    className,
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   id="Layer_1"
    //   data-name="Layer 1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 64 64"
    // >
    //   <g id="Layer_1-2" data-name="Layer_1">
    //     <path d="M57.34,50.8A6.25,6.25,0,0,1,51.21,57H13.91c-2,0-3.88-.27-5.42-1.87a6,6,0,0,1-1.83-4.3v-6.3a2.34,2.34,0,0,1,2.4-2.21,2.39,2.39,0,0,1,2.33,2.22v6.25c0,.82.39,1.46,1.67,1.44h37c1.13,0,2.5.28,2.53-1.4V13.67a1.55,1.55,0,0,0-1.73-1.51h-37c-1.1,0-2.49,0-2.53,1.51v5.55A2.43,2.43,0,0,1,9.1,21.47a2.48,2.48,0,0,1-2.45-2.24c0-2,0-3.69,0-5.65a6.19,6.19,0,0,1,6.19-6.19c12.76,0,25.53,0,38.29,0a6.21,6.21,0,0,1,6.2,6.2V50.81ZM42.06,34.88,29.93,46.79c-2.84,2.73-6.45-1.11-3.36-4l8-8.06H9.37a2.61,2.61,0,1,1,0-5.21H34.62l-8-8.06c-2.79-2.66.56-6.45,3.67-3.68l12,12,.39.39a2.81,2.81,0,0,1,.13,4c-.2.21-.41.45-.66.69Z" />
    //   </g>
    // </svg>

    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      viewBox="0 0 32 32"
    >
      <circle
        fill="none"
        stroke="#000000"
        stroke-width="2"
        stroke-miterlimit="10"
        cx="14"
        cy="11"
        r="6"
      />
      <path
        // style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
        fill="none"
        stroke="#000000"
        stroke-width="2"
        stroke-miterlimit="10"
        d="M5,26c0-4.971,4.029-9,9-9
	c1.864,0,3.596,0.567,5.032,1.537"
      />
      <circle
        // style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
        fill="none"
        stroke="#000000"
        stroke-width="2"
        stroke-miterlimit="10"
        cx="24"
        cy="24"
        r="7"
      />
      <line
        // style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
        fill="none"
        stroke="#000000"
        stroke-width="2"
        stroke-miterlimit="10"
        x1="21"
        y1="27"
        x2="27"
        y2="21"
      />
      <line
        // style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
        fill="none"
        stroke="#000000"
        stroke-width="2"
        stroke-miterlimit="10"
        x1="21"
        y1="21"
        x2="27"
        y2="27"
      />
    </svg>
  ),
  PlaylistAddIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    // <svg
    //   xmlns='http://www.w3.org/2000/svg'
    //   width={width}
    //   height={height}
    //   version='1.1'
    //   viewBox='0 0 573.01 444.41'
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    // >
    //   <g id='Layer_x0020_1'>
    //     <metadata id='CorelCorpID_0Corel-Layer' />
    //     <path
    //       className='fil0'
    //       d='M39.3 109.91c94.96,0 189.94,0 284.9,0 46.07,-0.02 46.33,70.72 -1.39,70.85 -69.76,0.18 -224.89,0.26 -284.05,0.05 -52.09,-0.1 -51.45,-70.91 0.54,-70.9zm0 110.74c94.96,0 65.51,0 160.46,0 46.08,-0.02 46.34,70.72 -1.38,70.85 -69.76,0.18 -100.45,0.26 -159.61,0.05 -52.09,-0.1 -51.45,-70.91 0.54,-70.9zm0 -220.65c94.96,0 189.94,0 284.9,0 46.07,-0.02 46.33,70.71 -1.39,70.85 -69.76,0.18 -224.89,0.26 -284.05,0.05 -52.09,-0.09 -51.45,-70.91 0.54,-70.9zm496.19 332.48c50.21,0.04 49.85,-66.67 -0.05,-66.69 -57.29,0.04 -23.18,0.08 -78.78,0.11 -0,-54.14 0.05,-27.99 0.06,-82.13 1.75,-49.89 -66.93,-50.34 -68.77,-2.18 -0.09,55.53 0.01,47.81 0.01,84.29 -54.96,-0.06 -28.26,-0.35 -79.29,0.11 -51.15,-0.43 -53.39,66.21 -2.59,66.5 57.35,0 31.94,0.05 81.89,0.06 -0.04,54.73 -0.02,23.93 0.01,78.61 -0.44,44.07 68.86,44.75 68.6,-0.51 0.26,-46.15 0.06,-31.92 0.07,-78.11 19.09,-0.03 15.49,-0.06 78.84,-0.06z'
    //     />
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M10.13,22.36H35.42c4.09,0,4.12,6.28-.12,6.29-6.19,0-20,0-25.22,0C5.46,28.65,5.51,22.36,10.13,22.36Zm0,9.83H24.38c4.09,0,4.11,6.28-.13,6.29-6.19,0-8.92,0-14.17,0-4.62,0-4.57-6.3.05-6.3Zm0-19.59H35.42c4.09,0,4.12,6.28-.12,6.29-6.19,0-20,0-25.22,0C5.46,18.89,5.51,12.6,10.13,12.6ZM54.18,42.12c4.46,0,4.43-5.92,0-5.92h-7c0-4.81,0-2.48,0-7.29a3.06,3.06,0,1,0-6.11-.19c0,4.93,0,4.24,0,7.48-4.88,0-2.51,0-7,0s-4.74,5.88-.23,5.9h7.27c0,4.86,0,2.12,0,7,0,3.91,6.11,4,6.09,0s0-2.83,0-6.93Z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  ThemeColorIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33337 10.6668H10.6667V5.3335H5.33337V10.6668ZM13.3334 26.6668H18.6667V21.3335H13.3334V26.6668ZM10.6667 26.6668H5.33337V21.3335H10.6667V26.6668ZM5.33337 18.6668H10.6667V13.3335H5.33337V18.6668ZM18.6667 18.6668H13.3334V13.3335H18.6667V18.6668ZM21.3334 5.3335V10.6668H26.6667V5.3335H21.3334ZM18.6667 10.6668H13.3334V5.3335H18.6667V10.6668ZM21.3334 18.6668H26.6667V13.3335H21.3334V18.6668ZM26.6667 26.6668H21.3334V21.3335H26.6667V26.6668Z"
      />
    </svg>
  ),
  // menuIcon: ({
  //   width = '24px',
  //   height = '24px',
  //   fill = '#BCBCBC',
  //   onClick,
  //   className,
  //   fill = '#999',
  // }) => (
  //   <svg
  //     width={width}
  //     height={height}
  //     fill={fill}
  //     onClick={onClick}
  //     className={className}
  //     id="Layer_1"
  //     data-name="Layer 1"
  //     xmlns="http://www.w3.org/2000/svg"
  //     viewBox="0 0 64 64"
  //   >
  //     <g id="Layer_1-2" data-name="Layer_1">
  //       <path
  //         d="M10.62,13.32H53.41a3.56,3.56,0,1,1,0,7.11H10.62C5.22,20.4,5.32,13.26,10.62,13.32Z"
  //         fill-rule="evenodd"
  //       />
  //       <path
  //         d="M10.62,28.23H53.41a3.56,3.56,0,1,1,0,7.11H10.62C5.22,35.3,5.32,28.16,10.62,28.23Z"
  //         fill-rule="evenodd"
  //       />
  //       <path
  //         d="M10.62,43.57H53.41a3.56,3.56,0,1,1,0,7.11H10.62C5.22,50.65,5.32,43.51,10.62,43.57Z"
  //         fill-rule="evenodd"
  //       />
  //     </g>
  //   </svg>
  // ),
  NotificationIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7203 22.72L24.0002 21V14.3333C24.0002 10.24 21.8136 6.81333 18.0003 5.90667V5C18.0003 3.89333 17.1069 3 16.0003 3C14.8936 3 14.0003 3.89333 14.0003 5V5.90667C10.1736 6.81333 8.00025 10.2267 8.00025 14.3333V21L6.28025 22.72C5.44025 23.56 6.02692 25 7.21358 25H24.7736C25.9736 25 26.5603 23.56 25.7203 22.72ZM10.6669 22.3333V14.3333C10.6669 11.0267 12.6803 8.33333 16.0003 8.33333C19.3203 8.33333 21.3336 11.0267 21.3336 14.3333V22.3333H10.6669ZM18.6669 26.3333C18.6669 27.8 17.4669 29 16.0003 29C14.5203 29 13.3336 27.8 13.3336 26.3333H18.6669Z"
      />
    </svg>
  ),
  NotificationIconFill: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0015 14.3333V21L25.7215 22.72C26.5615 23.56 25.9615 25 24.7749 25H7.21487C6.0282 25 5.44153 23.56 6.28153 22.72L8.00153 21V14.3333C8.00153 10.2267 10.1749 6.81333 14.0015 5.90667V5C14.0015 3.89333 14.8949 3 16.0015 3C17.1082 3 18.0015 3.89333 18.0015 5V5.90667C21.8149 6.81333 24.0015 10.24 24.0015 14.3333ZM18.6682 26.3333C18.6682 27.8 17.4682 29 16.0015 29C14.5215 29 13.3349 27.8 13.3349 26.3333H18.6682Z"
        fill="#C9000C"
      />
    </svg>
  ),
  FileIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
    >
      <g>
        <path d="M66.7,317.8h867.2v-38.1c0-10-4.4-20-11.2-26.2l0,0c-6.9-6.9-16.2-11.2-26.8-11.2l0,0H500l0,0c-64.2,0-92.3-29.3-117.2-54.3c-16.8-18.1-32.4-33.7-58.6-33.7l0,0H104.1l0,0c-10.6,0-19.9,3.8-26.8,10.6c-6.8,6.9-10.6,16.9-10.6,26.8L66.7,317.8L66.7,317.8z M922.7,835.1c6.8-6.9,11.2-16.2,11.2-26.8V373.9H66.7v434.4c0,10.6,3.8,20,10.6,26.8l0,0c6.8,6.9,16.2,11.2,26.8,11.2l0,0h791.8l0,0C906.5,846.4,915.8,842,922.7,835.1L922.7,835.1z M500,185.5h395.9c26.2,0,49.9,10.6,66.7,27.5c16.8,17.5,27.4,41.2,27.4,66.8v528.6c0,26.2-10.6,49.9-27.4,66.8c-16.8,16.9-40.5,27.5-66.7,27.5l0,0H104.1l0,0c-26.2,0-49.2-10.6-66.7-27.5l0,0C20.6,857.6,10,834.5,10,808.3l0,0V191.7l0,0c0-25.6,10.6-49.3,27.4-66.8l0,0c17.5-16.9,41.1-27.5,66.7-27.5l0,0h220.1l0,0c46.7,0,69.2,23.1,92.3,46.2C437.7,164.2,458.8,185.5,500,185.5L500,185.5z" />
      </g>
    </svg>
  ),
  themeIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   viewBox="0 -960 960 960"
    // >
    //   <path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-85 32-158t87.5-127q55.5-54 130-84.5T489-880q79 0 150 26.5T763.5-780q53.5 47 85 111.5T880-527q0 108-63 170.5T650-294h-75q-18 0-31 14t-13 31q0 27 14.5 46t14.5 44q0 38-21 58.5T480-80Zm0-400Zm-233 26q20 0 35-15t15-35q0-20-15-35t-35-15q-20 0-35 15t-15 35q0 20 15 35t35 15Zm126-170q20 0 35-15t15-35q0-20-15-35t-35-15q-20 0-35 15t-15 35q0 20 15 35t35 15Zm214 0q20 0 35-15t15-35q0-20-15-35t-35-15q-20 0-35 15t-15 35q0 20 15 35t35 15Zm131 170q20 0 35-15t15-35q0-20-15-35t-35-15q-20 0-35 15t-15 35q0 20 15 35t35 15ZM480-140q11 0 15.5-4.5T500-159q0-14-14.5-26T471-238q0-46 30-81t76-35h73q76 0 123-44.5T820-527q0-132-100-212.5T489-820q-146 0-247.5 98.5T140-480q0 141 99.5 240.5T480-140Z" />
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      // class="svg-icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      // xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667 0 49.962667-44.458667 85.333333-94.421334 85.333333H768a170.666667 170.666667 0 0 0-170.666667 170.666667v76.245333C597.333333 894.208 561.962667 938.666667 512 938.666667 276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333z m0 64a362.666667 362.666667 0 0 0 0 725.333334c4.736 0 9.002667-1.706667 13.098667-6.442667a36.992 36.992 0 0 0 8.234666-23.978667V768a234.666667 234.666667 0 0 1 234.666667-234.666667h76.245333c10.197333 0 18.730667-3.669333 23.978667-8.234666A16.512 16.512 0 0 0 874.666667 512 362.666667 362.666667 0 0 0 512 149.333333z"
      />
      <path
        d="M576 298.666667a64 64 0 1 0-128 0 64 64 0 0 0 128 0zM768 405.333333a64 64 0 1 0-128 0 64 64 0 0 0 128 0zM384 426.666667a64 64 0 1 0-128 0 64 64 0 0 0 128 0zM426.666667 661.333333a64 64 0 1 0-128 0 64 64 0 0 0 128 0z"
        fill={fill}
      />
    </svg>
  ),
  backgroundIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   viewBox="0 0 17 17"
    //   // xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M1.5 2.27778H3.05556M4.61111 5.38889H6.16667M5.38889 1.5V3.05556M2.27778 4.61111V6.16667M7.72222 2.27778H9.27778M10.8333 5.38889H12.3889M11.6111 1.5V3.05556M8.5 4.61111V6.16667M13.9444 2.27778H15.5M14.7222 4.61111V6.16667M1.5 8.5H3.05556M4.61111 11.6111H6.16667M5.38889 7.72222V9.27778M2.27778 10.8333V12.3889M7.72222 8.5H9.27778M10.8333 11.6111H12.3889M11.6111 7.72222V9.27778M8.5 10.8333V12.3889M13.9444 8.5H15.5M14.7222 10.8333V12.3889M1.5 14.7222H3.05556M5.38889 13.9444V15.5M7.72222 14.7222H9.27778M11.6111 13.9444V15.5M13.9444 14.7222H15.5"
    //     fill={fill}
    //   />
    // </svg>

    // <svg
    //   width="20px"
    //   height="20px"
    //   viewBox="0 0 20 20"
    //   // fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M1.5 2.27778H3.05556M4.61111 5.38889H6.16667M5.38889 1.5V3.05556M2.27778 4.61111V6.16667M7.72222 2.27778H9.27778M10.8333 5.38889H12.3889M11.6111 1.5V3.05556M8.5 4.61111V6.16667M13.9444 2.27778H15.5M14.7222 4.61111V6.16667M1.5 8.5H3.05556M4.61111 11.6111H6.16667M5.38889 7.72222V9.27778M2.27778 10.8333V12.3889M7.72222 8.5H9.27778M10.8333 11.6111H12.3889M11.6111 7.72222V9.27778M8.5 10.8333V12.3889M13.9444 8.5H15.5M14.7222 10.8333V12.3889M1.5 14.7222H3.05556M5.38889 13.9444V15.5M7.72222 14.7222H9.27778M11.6111 13.9444V15.5M13.9444 14.7222H15.5"
    //     // stroke="black"
    //     // stroke-width="1.66667"
    //     // stroke-linecap="round"
    //     // stroke-linejoin="round"
    //   />
    // </svg>

    // <svg
    //   width="17"
    //   height="17"
    //   viewBox="0 0 17 17"
    //   fill={fill}
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path d="M1.5 2.27778H3.05556M4.61111 5.38889H6.16667M5.38889 1.5V3.05556M2.27778 4.61111V6.16667M7.72222 2.27778H9.27778M10.8333 5.38889H12.3889M11.6111 1.5V3.05556M8.5 4.61111V6.16667M13.9444 2.27778H15.5M14.7222 4.61111V6.16667M1.5 8.5H3.05556M4.61111 11.6111H6.16667M5.38889 7.72222V9.27778M2.27778 10.8333V12.3889M7.72222 8.5H9.27778M10.8333 11.6111H12.3889M11.6111 7.72222V9.27778M8.5 10.8333V12.3889M13.9444 8.5H15.5M14.7222 10.8333V12.3889M1.5 14.7222H3.05556M5.38889 13.9444V15.5M7.72222 14.7222H9.27778M11.6111 13.9444V15.5M13.9444 14.7222H15.5" />
    // </svg>

    <svg
      fill="none"
      height={height}
      viewBox="0 0 48 48"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      // fill={fill}
    >
      <path d="m0 0h48v48h-48z" fill="none" />
      <g
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="4"
      >
        <path d="m6 8h4" />
        <path d="m14 16h4" />
        <path d="m16 6v4" />
        <path d="m8 14v4" />
        <path d="m22 8h4" />
        <path d="m30 16h4" />
        <path d="m32 6v4" />
        <path d="m24 14v4" />
        <path d="m38 8h4" />
        <path d="m40 14v4" />
        <path d="m6 24h4" />
        <path d="m14 32h4" />
        <path d="m16 22v4" />
        <path d="m8 30v4" />
        <path d="m22 24h4" />
        <path d="m30 32h4" />
        <path d="m32 22v4" />
        <path d="m24 30v4" />
        <path d="m38 24h4" />
        <path d="m40 30v4" />
        <path d="m6 40h4" />
        <path d="m16 38v4" />
        <path d="m22 40h4" />
        <path d="m32 38v4" />
        <path d="m38 40h4" />
      </g>
    </svg>
  ),
  EditProfileIcon: ({
    width = '24px',
    height = '24px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        d="M 8 2 C 6.3490681 2 5 3.3490681 5 5 C 5 6.6509319 6.3490681 8 8 8 C 9.6509319 8 11 6.6509319 11 5 C 11 3.3490681 9.6509319 2 8 2 z M 8 8 C 5.243 8 3 10.243 3 13 L 4 13 C 4 10.794 5.794 9 8 9 C 8.928 9 9.7721719 9.3303281 10.451172 9.8613281 L 11.150391 9.1503906 C 10.287391 8.4433906 9.2 8 8 8 z M 8 3 C 9.1104918 3 10 3.8895082 10 5 C 10 6.1104918 9.1104918 7 8 7 C 6.8895082 7 6 6.1104918 6 5 C 6 3.8895082 6.8895082 3 8 3 z M 14.205078 8.0039062 C 13.87855 8.0059963 13.553783 8.1310493 13.310547 8.3808594 L 8.6464844 13.123047 L 7.9511719 16.048828 L 10.876953 15.353516 L 10.974609 15.255859 L 15.619141 10.689453 C 16.118761 10.202981 16.12374 9.3874144 15.630859 8.8945312 L 15.105469 8.3691406 C 14.859027 8.1226991 14.531606 8.0018122 14.205078 8.0039062 z M 14.210938 8.9960938 C 14.277619 8.9957637 14.344879 9.0226118 14.398438 9.0761719 L 14.923828 9.6015625 C 15.030945 9.7086795 15.030302 9.8690817 14.921875 9.9746094 L 14.919922 9.9746094 L 10.376953 14.443359 L 9.2988281 14.701172 L 9.5546875 13.626953 L 14.025391 9.0800781 L 14.025391 9.078125 C 14.078154 9.0239351 14.144256 8.9964238 14.210938 8.9960938 z"
        font-weight="400"
        font-family="sans-serif"
        white-space="normal"
        overflow="visible"
      />
    </svg>
  ),
  ThreeDLogo: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M10.48,17.57v29c4.7,2.35,17.22,8.61,21.13,11,2.35-.79,18-8.61,21.91-11V17.57l-21.91-11C28.48,8.18,12.83,16,10.48,17.57ZM44.73,34.12,31.8,42a1.88,1.88,0,0,1-2.69-1.71L29,24.76a1.75,1.75,0,0,1,2.72-1.6l13,7.73A1.8,1.8,0,0,1,44.73,34.12Zm-13.1-8.88,11.46,6.83A.52.52,0,0,1,43,33L31.35,40.12a.34.34,0,0,1-.45-.28l-.08-14.18A.52.52,0,0,1,31.63,25.24Zm19.26-2.46L43.1,27.06l-12.1-7a2.63,2.63,0,0,0-4,2.11V42.81A2.69,2.69,0,0,0,31,45.09l12.2-7,7.74,4.26c0-7.91,0-13.62,0-19.53Z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  LanguageIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path d="M20 18h-1.44a.61.61 0 0 1-.4-.12.81.81 0 0 1-.23-.31L17 15h-5l-1 2.54a.77.77 0 0 1-.22.3.59.59 0 0 1-.4.14H9l4.55-11.47h1.89zm-3.53-4.31L14.89 9.5a11.62 11.62 0 0 1-.39-1.24q-.09.37-.19.69l-.19.56-1.58 4.19zm-6.3-1.58a13.43 13.43 0 0 1-2.91-1.41 11.46 11.46 0 0 0 2.81-5.37H12V4H7.31a4 4 0 0 0-.2-.56C6.87 2.79 6.6 2 6.6 2l-1.47.5s.4.89.6 1.5H0v1.33h2.15A11.23 11.23 0 0 0 5 10.7a17.19 17.19 0 0 1-5 2.1q.56.82.87 1.38a23.28 23.28 0 0 0 5.22-2.51 15.64 15.64 0 0 0 3.56 1.77zM3.63 5.33h4.91a8.11 8.11 0 0 1-2.45 4.45 9.11 9.11 0 0 1-2.46-4.45z" />
    </svg>
  ),

  usersIcon: ({
    width = '14px',
    height = '14px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (

    <svg
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
    >
      {/* <metadata>
        {' '}
        Svg Vector Icons : http://www.onlinewebfonts.com/icon{' '}
      </metadata> */}
      <g>
        <path d="M505.4,539.1c69.4-41.4,116.3-117.9,116.3-205.3c0-131.4-105.4-238.4-235-238.4c-129.6,0-235,106.9-235,238.4c0,89,48.4,166.7,119.9,207.6C129.7,587.7,24.3,713.8,10.1,870.7c-1.5,17.1,11.1,32.2,28.2,33.8c17.1,1.6,32.2-11.1,33.8-28.2c15-166.5,152.5-292,319.8-292c167.3,0,304.8,125.6,319.8,292c1.5,16.2,15,28.3,30.9,28.3c0.9,0,1.9,0,2.8-0.1c17.1-1.5,29.7-16.7,28.2-33.8C759.2,711.3,650.7,583.6,505.4,539.1L505.4,539.1z M213.8,333.8c0-97.1,77.5-176.2,172.8-176.2c95.3,0,172.8,79,172.8,176.2c0,97.1-77.5,176.2-172.8,176.2C291.4,510,213.8,430.9,213.8,333.8L213.8,333.8z" />
        <path d="M989.9,870.7c-14.4-159.4-122.8-287.1-268.1-331.6C791.2,497.7,838,421.3,838,333.8c0-131.4-105.4-238.4-235-238.4c-29.1,0-56.9,5.4-82.6,15.2c23.1,12.6,43.9,29,61.6,48.3c6.9-0.9,13.9-1.3,21.1-1.3c95.3,0,172.8,79,172.8,176.2c0,97.1-77.5,176.2-172.8,176.2c-7.2,0-14.4-0.5-21.4-1.4c-8.3,8.7-17.2,16.7-26.7,24.1c21.8,9.8,42.6,21.6,62,35.2c9.7,5.5,18.9,11.6,27.7,18.4C795,603,914,722,927.9,876.3c1.5,16.2,15,28.3,30.9,28.3c0.9,0,1.9,0,2.8-0.1C978.8,902.9,991.4,887.8,989.9,870.7z" />
      </g>
    </svg>
  ),
  userIcon: ({
    width = '14px',
    height = '14px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (

       <svg
       onClick={onClick}
      className={className}
      width={width}
      height={height}
       id="SvgjsSvg1001"  xmlns="http://www.w3.org/2000/svg" version="1.1" ><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" ><rect   fill="none"></rect><circle cx="128" cy="96" r="64" fill="none" stroke={fill} stroke-linecap="round" stroke-linejoin="round" stroke-width="24" class="colorStroke000 svgStroke"></circle><path fill="none" stroke={fill} stroke-linecap="round" stroke-linejoin="round" stroke-width="24" d="M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002" class="colorStroke000 svgStroke"></path></svg></g></svg>
    

  ),
  GroupIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    onClick,
    className,
  }) => (
    <svg
      enable-background="new 0 0 91 91"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 91 91"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
    >
      <g>
        <path d="M46.252,22.97c-6.738,0-12.219,5.484-12.219,12.223c0,2.725,0.907,5.236,2.42,7.27c-2.98,2.084-4.777,5.191-4.777,8.521   v17.369h3.4V50.983c0-2.371,1.436-4.619,3.804-6.068c2.052,1.561,4.601,2.498,7.372,2.498c2.806,0,5.385-0.959,7.451-2.557   c2.427,1.449,3.897,3.719,3.897,6.127v17.369H61V50.983c0-3.383-1.839-6.516-4.89-8.598c1.479-2.021,2.363-4.504,2.363-7.193   C58.474,28.454,52.991,22.97,46.252,22.97z M46.252,44.015c-4.863,0-8.818-3.959-8.818-8.822c0-4.865,3.955-8.822,8.818-8.822   c4.864,0,8.822,3.957,8.822,8.822C55.074,40.056,51.116,44.015,46.252,44.015z" />
        <path d="M18.976,48.233c0-1.043,0.596-2.037,1.579-2.768c1.26,0.838,2.768,1.33,4.391,1.33c4.394,0,7.969-3.572,7.969-7.965   c0-4.395-3.575-7.969-7.969-7.969c-4.393,0-7.965,3.574-7.965,7.969c0,1.529,0.453,2.943,1.202,4.156   c-1.642,1.359-2.607,3.242-2.607,5.246v10.084h3.4V48.233z M24.945,34.263c2.52,0,4.568,2.049,4.568,4.568   c0,2.516-2.049,4.564-4.568,4.564c-2.518,0-4.565-2.049-4.565-4.564C20.38,36.312,22.428,34.263,24.945,34.263z" />
        <path d="M74.422,42.931c0.729-1.201,1.172-2.596,1.172-4.1c0-4.395-3.574-7.969-7.966-7.969c-4.394,0-7.969,3.574-7.969,7.969   c0,4.393,3.575,7.965,7.969,7.965c1.646,0,3.178-0.502,4.448-1.361c1.01,0.73,1.621,1.738,1.621,2.799v10.084h3.4V48.233   C77.098,46.194,76.106,44.288,74.422,42.931z M67.628,43.396c-2.52,0-4.569-2.049-4.569-4.564c0-2.52,2.05-4.568,4.569-4.568   c2.518,0,4.565,2.049,4.565,4.568C72.193,41.347,70.146,43.396,67.628,43.396z" />
      </g>
    </svg>
  ),
};

export default ToolbarIcons;
